/**
 * menu-control.top.js
 *
 * @package Wordpress/imhof-digital
 * @since 20191230
 * @author Imhof Digital <info@imhof-digital.de>
 */

jQuery( document ).ready( function( $ ) {
   // declare strict mode
   'use strict';

   if( idscript ) {
      idscript.menuControl = {
         setClickHandler: function() {
            $( '#id-menu-control' ).on( 'click', idscript.menuControl.clickHandler );
            return;
         },
         clickHandler: function() {
            if( $( '#id-menu-control' ).hasClass( 'open' ) ) {
               $( '#id-menu-control' ).removeClass( 'open' ).addClass( 'close' );
               $( '#mainmenu' ).removeClass( 'open' ).addClass( 'close' );
            } else {
               $( '#id-menu-control' ).addClass( 'open' ).removeClass( 'close' );
               $( '#mainmenu' ).addClass( 'open' ).removeClass( 'close' );
            }
            return;
         },
         init: function() {
            idscript.menuControl.setClickHandler();
            return;
         }
      };
      idscript.menuControl.init();
   }
} );
